import guestRoutes from "./guest";
import errorRoutes from "./error";

const routes = [...guestRoutes, ...errorRoutes];

export default routes;
